module.exports = __webpack_public_path__ + "img/memorial_logo.3d53be51.png";